import Vector from "victor";

export default class AnimationFrameMoveController {
  isPointerDown = false;
  animationFrameHandle = 0;
  lastScreenSpacePoint = new Vector(
    Number.MAX_SAFE_INTEGER,
    Number.MAX_SAFE_INTEGER
  );
  lastFiredPoint = new Vector(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
  onMove: (point: Vector) => void;

  constructor(onMove: (point: Vector) => void) {
    this.onMove = onMove;
  }

  // eslint-ignore-next-line
  onPointerDown = (point: Vector) => {
    this.isPointerDown = true;
    this.lastScreenSpacePoint = point;

    // Start RAF loop
    this.animationFrameHandle = window.requestAnimationFrame(
      this.handleAnimationFrame
    );
  };

  onPointerMove = (point: Vector) => {
    if (!this.isPointerDown) return;

    // Save latest mouse point but otherwise do nothing (handleAnimationFrame
    // is the important part)
    this.lastScreenSpacePoint = point;
  };

  handleAnimationFrame = () => {
    if (!this.isPointerDown) return;

    if (this.lastScreenSpacePoint.x === Number.MAX_SAFE_INTEGER) {
      return;
    }

    // Request another animation frame
    this.animationFrameHandle = window.requestAnimationFrame(
      this.handleAnimationFrame
    );

    if (this.lastScreenSpacePoint.isEqualTo(this.lastFiredPoint)) return;
    this.lastFiredPoint = this.lastScreenSpacePoint;
    this.onMove(this.lastScreenSpacePoint);
  };

  onPointerUp = () => {
    if (!this.isPointerDown) return;
    this.abort();
  };

  abort() {
    this.isPointerDown = false;
    this.lastScreenSpacePoint = new Vector(
      Number.MAX_SAFE_INTEGER,
      Number.MAX_SAFE_INTEGER
    );
    window.cancelAnimationFrame(this.animationFrameHandle);
  }
}
